import React from 'react';
import { motion } from 'framer-motion';
import { Menu, X, Globe } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { LANG_BUTTON_HOVER, LANG_BUTTON_TAP } from './navbarConfig';

const MobileMenuToggle = ({ isOpen, onToggle }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div className="md:hidden flex items-center space-x-4">
      <motion.button
        whileHover={LANG_BUTTON_HOVER}
        whileTap={LANG_BUTTON_TAP}
        onClick={toggleLanguage}
        data-testid="mobile-language-toggle"
        className="flex items-center space-x-1 px-2 py-1 rounded-lg bg-slate-800"
      >
        <Globe className="w-4 h-4 text-blue-400" />
        <span className="text-xs text-white font-medium">{language.toUpperCase()}</span>
      </motion.button>

      <button onClick={onToggle} className="text-white" aria-label="Toggle menu" data-testid="mobile-menu-toggle">
        {isOpen ? <X size={28} /> : <Menu size={28} />}
      </button>
    </div>
  );
};

export default MobileMenuToggle;
